export const BASE_URL = "https://api.github.com";
export const OCTOCAT_USER_NAME = "octocat";
export const REPOS_PER_PAGE = 12;
